export default __webpack_public_path__ + "static/media/contact_icon_small.76b2363f.svg";